import clsx from 'clsx';
import React, { useRef } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import TrashIcon from '@/icons/TrashIcon';
import i18n from '@i18n';
import { SingleUpload } from '@/uploadDocument/views/DocumentUploader';
import '@/uploadDocument/subs';
import '@/uploadDocument/handlers';
import './UploadField.less';

export default function UploadField({ config, slot, page = 1 }) {
    const derefSub = useReframe();
    const progress = derefSub(['documentsUpload.uploadProgress', slot, config.get('documentId'), page]);
    const uploadDone = progress && progress.get('done');
    const ref = useRef();

    function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        dispatch(['documentsUpload.cleanSingleFailedUpload', { slot, page }]);
        ref.current.setError(null);
    }

    const selectedDocument = config?.get('documents').get(0);
    return (
        <label className={clsx('field upload user-verification', { empty: !uploadDone })}>
            <div className="account-wrap">
                <div className="doc-upload-box">
                    <div className="doc-containers-box">
                        <div className="doc-container">
                            <SingleUpload
                                ref={ref}
                                slot={slot}
                                slotName={selectedDocument.get('slotName')}
                                documentId={selectedDocument.get('documentId')}
                                page={page}
                                clientHash={selectedDocument.get('clientHash')}
                                help={i18n('contactus.docs.help')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {uploadDone ? (
                <button className="remove" onClick={onClick}>
                    <TrashIcon fill="#FF224D" />
                    {i18n('Odobrať')}
                </button>
            ) : null}
        </label>
    );
}
